import { TweenMax, Power4 } from 'gsap/all';

export default function title(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = TweenMax.fromTo(elToTween, 1, {
    x: 100,
    skewX: -30,
    autoAlpha: 0,
    transformOrigin: 'center',
  }, {
    x: 0,
    skewX: 0,
    autoAlpha: 1,
    ease: Power4.easeOut,
    clearProps: 'all',
  });

  return tween;
}
